import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import PropTypes from 'prop-types';
import {
  PageContent,
  PageHeader,
  PageWrapper,
  StyledTabs,
  GlobalPopupButtonStyles
} from './styled';
import SingleNameScreening from './nameScreening/SingleNameScreening';
import BulkUpload from './bulkUpload/BulkUpload';
import {
  BULK_SCANNING_FLOW,
  BULK_SCREENING_FLOW
} from '../../constants/nsConstants';
import {
  showScanningPopup,
  showScreeningPopup
} from '../../../redux/actions/ns/onDemandScreening';
import { keys } from 'lodash';
import HistoryOnDemand from './history/index';
import AlertList from './alertList/AlertList';
import { fetchAMLSAlertLevel } from '../../../redux/actions/common';

const { TabPane } = Tabs;

const OnDemandScreening = ({
  location,
  history,
  dispatch,
  bulkScreeningStarted,
  isShowScanModal,
  isShowScreenModal,
  currentScreeningState
}) => {
  const [activeTab, setActiveTab] = useState('1');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setActiveTab(queryParams?.get('tabId') || '1');
  }, [location]);

  const showScreeningModal = () => {
    if (bulkScreeningStarted && !isShowScanModal && !isShowScreenModal) {
      if (keys(BULK_SCANNING_FLOW).includes(currentScreeningState)) {
        dispatch(showScanningPopup(true));
      } else if (keys(BULK_SCREENING_FLOW).includes(currentScreeningState)) {
        dispatch(showScreeningPopup(true));
      }
    }
  };

  useEffect(() => {
    showScreeningModal();
    //Get alert level config values for filters and others
    dispatch(fetchAMLSAlertLevel());
  }, []);

  const onTabChange = (activeKey) => {
    setActiveTab(activeKey);
    if (activeKey === '2') showScreeningModal();
  };

  return (
    <PageWrapper>
      <PageHeader>On Demand Screening</PageHeader>
      <PageContent>
        <StyledTabs activeKey={activeTab} onChange={onTabChange}>
          <TabPane
            tab="Single Name Screening"
            key="1"
            disabled={bulkScreeningStarted}>
            <SingleNameScreening history={history} />
          </TabPane>
          <TabPane tab="Bulk Upload" key="2">
            <BulkUpload onTabChange={onTabChange} history={history} />
          </TabPane>
          <TabPane tab="Alert History" key="3">
            <HistoryOnDemand />
          </TabPane>
          <TabPane tab="Alert Listing" key="4">
            <AlertList
              activeTab={activeTab}
              history={history}
              location={location}
            />
          </TabPane>
        </StyledTabs>
      </PageContent>
      <GlobalPopupButtonStyles />
    </PageWrapper>
  );
};

OnDemandScreening.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  bulkScreeningStarted: PropTypes.bool,
  isShowScanModal: PropTypes.bool,
  isShowScreenModal: PropTypes.bool,
  currentScreeningState: PropTypes.string
};

const mapStateToProps = (state) => {
  const {
    bulkScreening: {
      bulkScreeningStarted,
      isShowScanModal,
      isShowScreenModal,
      currentScreeningState
    }
  } = state.nsOnDemandScreening;
  return {
    bulkScreeningStarted,
    isShowScanModal,
    isShowScreenModal,
    currentScreeningState
  };
};

export default connect(mapStateToProps)(OnDemandScreening);
